import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  ValidateTokenRequest,
  ValidateTokenResponse
} from './validateToken.types'

export const validateToken = async (data: ValidateTokenRequest) => {
  const response = await authApi.post<ValidateTokenResponse>(
    '/innos/validate-token',
    data
  )
  return response.data
}

export const useValidateTokenMutation = (
  options?: ExtendableMutationOptions<
    ValidateTokenResponse,
    ValidateTokenRequest
  >
) => {
  return useMutation({
    mutationFn: data => validateToken(data),
    ...options
  })
}
